module.exports = __webpack_public_path__ + "img/3d-export_en.1994f4b.jpg";